import { AnimatePresence } from 'framer-motion';
import { useUIStore } from '@/stores/ui-store';
import Toast from './Toast';

export default function ToastProvider() {
  const toasts = useUIStore((s) => s.toasts);
  const removeToast = useUIStore((s) => s.removeToast);

  return (
    <div
      aria-live="polite"
      aria-label="Notifications"
      className="fixed top-4 right-4 z-[100] flex flex-col gap-2 w-full max-w-sm pointer-events-none"
    >
      <AnimatePresence mode="popLayout">
        {toasts.map((toast) => (
          <div key={toast.id} className="pointer-events-auto">
            <Toast
              id={toast.id}
              message={toast.message}
              type={toast.type}
              onDismiss={removeToast}
            />
          </div>
        ))}
      </AnimatePresence>
    </div>
  );
}
